module.exports = __webpack_public_path__ + "static/pave-zircon-plain-double-cuff-hoop-e4bce654aed4b7348824813569163268.jpg";